import { apiClient } from '@/shared/services/api/client';
import { unwrapEnvelope } from '@/shared/services/api/envelope';
import type { ApiEnvelope } from '@/shared/services/api/envelope';
import type { SupplierVenAi, VenAiEvaluation, VenAiInputs, VenAiRecommendations } from '../models/venAi.types';

/**
 * VEN AI's HTTP layer (2026-11-02): a supplier's values per category (`/ven-ai/suppliers/{id}`, the Supplier master's
 * VEN AI tab) and a BID's ranked suppliers (`/rfqs/{id}/ven-ai/recommendations`, AI Insights). Scored under the
 * weightage of the entity the shell has selected.
 */

const FALLBACK = 'Server error, please try again';

export const venAiApi = {
  async supplier(supplierId: number): Promise<SupplierVenAi> {
    const response = await apiClient.get<ApiEnvelope<SupplierVenAi>>(`/ven-ai/suppliers/${String(supplierId)}`);
    return unwrapEnvelope(response, FALLBACK);
  },

  async save(supplierId: number, categoryId: number, inputs: VenAiInputs): Promise<VenAiEvaluation> {
    const response = await apiClient.put<ApiEnvelope<VenAiEvaluation>>(
      `/ven-ai/suppliers/${String(supplierId)}/categories/${String(categoryId)}`,
      inputs,
    );
    return unwrapEnvelope(response, FALLBACK);
  },

  async recommendations(rfqId: number): Promise<VenAiRecommendations> {
    const response = await apiClient.get<ApiEnvelope<VenAiRecommendations>>(
      `/rfqs/${String(rfqId)}/ven-ai/recommendations`,
    );
    return unwrapEnvelope(response, FALLBACK);
  },
};
